const SERVICES = [
  {
    slug: "depannage-maintenance",
    ico: "wrench",
    name: "Dépannage & Maintenance",
    tagline: "Un support technique réactif pour ne jamais être bloqué.",
    paragraphs: [
      "Un ordinateur qui plante en pleine journée, une imprimante qui refuse d'imprimer, un réseau Wi-Fi capricieux : ces petits soucis techniques peuvent vite ralentir toute une équipe. Nos techniciens interviennent rapidement, sur site à Dakar ou à distance, pour diagnostiquer et résoudre le problème sans perdre votre journée.",
      "Au-delà du dépannage ponctuel, nous proposons des contrats de maintenance mensuelle : surveillance de vos équipements, mises à jour de sécurité et intervention prioritaire en cas d'incident, pour anticiper les pannes avant qu'elles ne vous coûtent du temps ou de l'argent.",
    ],
    features: ["Réparation PC, Mac & périphériques", "Dépannage réseau & Wi-Fi", "Intervention sur site ou à distance", "Contrats de maintenance mensuelle", "Installation & configuration de matériel"],
    benefits: [
      { t: "Réactivité", d: "Intervention rapide pour limiter l'impact sur votre activité." },
      { t: "Prévention", d: "Un suivi régulier pour éviter les pannes plutôt que de les subir." },
      { t: "Tarifs clairs", d: "Un devis avant toute intervention, sans mauvaise surprise." },
    ],
    idealFor: ["Commerces & bureaux", "Petites équipes sans service IT", "Professions libérales", "Associations"],
  },
  {
    slug: "creation-contenus",
    ico: "camera",
    name: "Création de Contenus",
    tagline: "Des visuels professionnels qui donnent envie de vous faire confiance.",
    paragraphs: [
      "Photos produits soignées, vidéos de présentation, affiches et flyers percutants : la qualité de vos visuels influence directement la confiance que vous inspirez à vos clients. On s'occupe du shooting, du montage et de la mise en forme pour que chaque support reflète le sérieux de votre activité.",
      "Que ce soit pour votre site, vos réseaux sociaux ou vos supports imprimés, nous adaptons chaque création à votre identité visuelle, pour une image cohérente partout où vos clients vous croisent.",
    ],
    features: ["Shooting photo produits & équipe", "Vidéos de présentation courtes", "Flyers, affiches & supports imprimés", "Habillage visuel réseaux sociaux", "Retouche & montage inclus"],
    benefits: [
      { t: "Image professionnelle", d: "Des visuels qui inspirent confiance dès le premier regard." },
      { t: "Cohérence de marque", d: "Un style uniforme sur tous vos supports, en ligne et imprimés." },
      { t: "Gain de temps", d: "Vous recevez des contenus prêts à l'emploi, sans effort de votre côté." },
    ],
    idealFor: ["Boutiques & commerces", "Restaurants", "Salons de beauté", "Indépendants & artisans"],
  },
  {
    slug: "google-business",
    ico: "mapPin",
    name: "Google Business",
    tagline: "Soyez visible au bon moment, auprès des bonnes personnes.",
    paragraphs: [
      "Votre fiche Google est souvent le tout premier contact entre un client potentiel et votre entreprise, bien avant qu'il ne visite votre site ou pousse votre porte. On l'optimise avec des photos, des horaires à jour et une description claire, pour qu'elle donne immédiatement envie de vous choisir.",
      "On s'occupe aussi de la gestion de vos avis clients et du référencement local, pour que votre entreprise apparaisse en priorité lorsque quelqu'un recherche vos services près de chez lui.",
    ],
    features: ["Optimisation complète de la fiche", "Gestion & réponse aux avis clients", "Référencement local (SEO)", "Suivi des statistiques de recherche", "Mise à jour régulière des informations"],
    benefits: [
      { t: "Visibilité locale", d: "Apparaître en priorité pour les recherches autour de vous." },
      { t: "Confiance renforcée", d: "Des avis bien gérés rassurent les clients hésitants." },
      { t: "Résultats mesurables", d: "Un suivi clair de l'évolution de votre visibilité." },
    ],
    idealFor: ["Commerces de proximité", "Restaurants & cafés", "Professions de santé", "Services à domicile"],
  },
  {
    slug: "logiciel-gestion",
    ico: "barChart",
    name: "Logiciel de Gestion",
    tagline: "Arrêtez de tout gérer sur papier ou dans plusieurs fichiers.",
    paragraphs: [
      "Caisse, stocks, ventes, équipes : gérer une activité sans outil adapté fait perdre du temps et multiplie les erreurs. Nous développons un logiciel de gestion sur-mesure, pensé pour votre secteur, simple à prendre en main pour vous et votre équipe.",
      "Tout est centralisé au même endroit, accessible en temps réel, avec des accès adaptés selon les membres de votre équipe : plus besoin de recouper plusieurs fichiers pour savoir où vous en êtes.",
    ],
    features: ["Gestion de caisse & encaissements", "Suivi des stocks en temps réel", "Rapports de ventes automatiques", "Accès multi-utilisateurs sécurisé", "Formation de votre équipe incluse"],
    benefits: [
      { t: "Moins d'erreurs", d: "Un seul outil centralisé, plus de doubles saisies." },
      { t: "Vision claire", d: "Vos chiffres en temps réel, sans attendre la fin du mois." },
      { t: "Sur-mesure", d: "Un outil pensé pour votre activité, pas un logiciel générique." },
    ],
    idealFor: ["Boutiques & commerces", "Restaurants", "Grossistes & distributeurs", "PME avec plusieurs employés"],
  },
  {
    slug: "creation-sites-web",
    ico: "globe",
    name: "Création de Sites Web",
    tagline: "Un site rapide, moderne, et qui vend pour vous.",
    paragraphs: [
      "Site vitrine, boutique en ligne ou portfolio : nous concevons des sites modernes, pensés mobile en premier, qui donnent une image professionnelle de votre activité dès la première visite.",
      "Chaque site est optimisé pour le référencement (SEO) dès sa conception, pour être trouvé facilement sur Google, et livré dans des délais courts sans sacrifier la qualité.",
    ],
    features: ["Design sur-mesure & responsive", "Boutique en ligne & paiement", "Optimisation SEO dès la conception", "Formulaires & prise de rendez-vous", "Hébergement & nom de domaine"],
    benefits: [
      { t: "Image professionnelle", d: "Un site qui inspire confiance et reflète votre sérieux." },
      { t: "Trouvable sur Google", d: "Une base SEO solide dès le lancement." },
      { t: "Livraison rapide", d: "Un site en ligne en quelques jours, pas en plusieurs mois." },
    ],
    idealFor: ["Commerces souhaitant vendre en ligne", "Cabinets & professions libérales", "Restaurants & hôtels", "Startups & nouvelles entreprises"],
  },
  {
    slug: "packs-business-pro",
    ico: "package",
    name: "Packs Business Pro",
    tagline: "Toutes nos solutions réunies dans une seule offre cohérente.",
    paragraphs: [
      "Plutôt que de choisir un service à la fois, le Pack Business Pro combine site web, présence Google, branding et logiciel de gestion dans une offre pensée pour avancer vite, avec un seul interlocuteur.",
    ],
    features: ["Site web professionnel inclus", "Fiche Google Business optimisée", "Logiciel de gestion sur-mesure", "Formation & suivi 3 mois"],
    benefits: [],
    idealFor: [],
    isPackRedirect: true,
  },
  {
    slug: "marketing-digital",
    ico: "megaphone",
    name: "Marketing Digital",
    tagline: "Attirer de nouveaux clients, fidéliser les vôtres.",
    paragraphs: [
      "Une belle présence en ligne ne suffit pas si personne ne la voit. On construit une stratégie réseaux sociaux claire, on lance des campagnes publicitaires ciblées sur Meta et Google Ads, et on anime vos comptes au quotidien pour toucher les bonnes personnes.",
      "Chaque mois, vous recevez un reporting simple pour comprendre ce qui fonctionne et ajuster la stratégie en fonction de vos résultats, pas de vos impressions.",
    ],
    features: ["Stratégie réseaux sociaux", "Campagnes Meta & Google Ads", "Community management quotidien", "Calendrier éditorial mensuel", "Reporting mensuel des résultats"],
    benefits: [
      { t: "Nouveaux clients", d: "Des campagnes ciblées pour toucher les bonnes personnes." },
      { t: "Fidélisation", d: "Une présence régulière qui garde le contact avec vos clients." },
      { t: "Résultats suivis", d: "Un reporting clair, pas de chiffres flous." },
    ],
    idealFor: ["Commerces & marques locales", "Restaurants", "Cabinets de conseil", "Salons & instituts"],
  },
  {
    slug: "automatisation",
    ico: "zap",
    name: "Automatisation",
    tagline: "Libérez du temps sur les tâches répétitives.",
    paragraphs: [
      "Emails de relance, rapports hebdomadaires, transferts de données entre vos outils : ces tâches répétitives prennent un temps précieux quand elles sont faites à la main, et sont sources d'erreurs. On les automatise pour vous.",
      "Le résultat : des heures récupérées chaque semaine, des rapports toujours à jour, et une équipe qui se concentre sur ce qui a vraiment de la valeur pour votre activité.",
    ],
    features: ["Automatisation des emails clients", "Rapports & tableaux de bord auto", "Connexion entre vos outils existants", "Alertes & notifications automatiques", "Workflows sur-mesure"],
    benefits: [
      { t: "Temps gagné", d: "Des heures récupérées chaque semaine sur les tâches répétitives." },
      { t: "Moins d'erreurs", d: "Des processus fiables, sans oubli ni double saisie." },
      { t: "Données à jour", d: "Des rapports générés automatiquement, toujours actuels." },
    ],
    idealFor: ["PME avec processus répétitifs", "Grossistes & distributeurs", "Cabinets avec beaucoup de suivi client", "Équipes commerciales"],
  },
  {
    slug: "conseil-digital",
    ico: "sparkle",
    name: "Conseil Digital",
    tagline: "Une feuille de route claire pour avancer sereinement.",
    paragraphs: [
      "Avant de se lancer dans un projet digital, mieux vaut savoir où on va. On réalise un audit complet de votre présence numérique actuelle — site, réseaux sociaux, visibilité Google, outils internes — pour identifier ce qui fonctionne et ce qui vous freine.",
      "Vous repartez avec une feuille de route claire et priorisée, adaptée à votre budget et à vos objectifs, que vous décidiez de la mettre en œuvre avec nous ou en interne.",
    ],
    features: ["Audit digital complet", "Analyse de la concurrence", "Feuille de route priorisée", "Recommandations budgétaires", "Accompagnement à la décision"],
    benefits: [
      { t: "Clarté", d: "Vous savez enfin par où commencer, sans vous disperser." },
      { t: "Priorisation", d: "Des actions classées par impact, pas une liste sans fin." },
      { t: "Objectivité", d: "Un regard extérieur, sans parti pris sur vos choix passés." },
    ],
    idealFor: ["Entreprises en pleine réflexion digitale", "PME en croissance", "Dirigeants souhaitant être conseillés", "Associations & structures publiques"],
  },
];

export default SERVICES;